export default __webpack_public_path__ + "static/Yeppy-15b2693e5b6a177e3aa51e677af4e626.webp";